import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="py-8 px-4 bg-[#3D3D3D] text-white/60" data-id="element-55">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-56">
          <p className="text-sm" data-id="element-57">
            © 2024 Agenda Antiansiedad. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-58">
            <button onClick={() => setActiveModal('privacy')} className="text-sm hover:text-white transition-colors duration-200" data-id="element-59">
              Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-sm hover:text-white transition-colors duration-200" data-id="element-60">
              Términos
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-61">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={closeModal} data-id="element-62">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.2
        }} className="relative w-full max-w-2xl max-h-[80vh] bg-white rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-63">
              {/* Header */}
              <div className="sticky top-0 flex items-center justify-between p-6 bg-[#FAF8F5] border-b border-[#E5E0D8]" data-id="element-64">
                <h2 className="text-xl font-serif text-[#3D3D3D]" data-id="element-65">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={closeModal} className="p-2 rounded-full hover:bg-[#3D3D3D]/10 transition-colors duration-200" data-id="element-66">
                  <X size={20} className="text-[#3D3D3D]" data-id="element-67" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-68">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-69" /> : <TermsContent data-id="element-70" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <div className="prose prose-sm max-w-none text-[#5A6B5A]" data-id="element-71">
      <p className="text-sm text-[#8B9E8B] mb-4" data-id="element-72">
        Última actualización: Enero 2024
      </p>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-73">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-74">
        Al adquirir la Agenda Antiansiedad de 14 Días, recopilamos únicamente la
        información necesaria para procesar tu compra:
      </p>
      <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-75">
        <li data-id="element-76">Dirección de correo electrónico para enviar tu producto digital</li>
        <li data-id="element-77">
          Información de pago procesada de forma segura por nuestro proveedor de
          pagos
        </li>
      </ul>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-78">
        2. Uso de la Información
      </h3>
      <p data-id="element-79">Tu información se utiliza exclusivamente para:</p>
      <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-80">
        <li data-id="element-81">Entregar el producto digital que adquiriste</li>
        <li data-id="element-82">Enviarte actualizaciones importantes sobre tu compra</li>
        <li data-id="element-83">Responder a tus consultas de soporte</li>
      </ul>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-84">
        3. Protección de Datos
      </h3>
      <p data-id="element-85">
        Implementamos medidas de seguridad para proteger tu información
        personal. No vendemos, intercambiamos ni transferimos tu información a
        terceros sin tu consentimiento.
      </p>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-86">
        4. Cookies
      </h3>
      <p data-id="element-87">
        Utilizamos cookies esenciales para el funcionamiento del sitio y para
        mejorar tu experiencia de navegación. Puedes configurar tu navegador
        para rechazar cookies.
      </p>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-88">
        5. Tus Derechos
      </h3>
      <p data-id="element-89">
        Tienes derecho a acceder, rectificar o eliminar tus datos personales en
        cualquier momento. Para ejercer estos derechos, puedes contactarnos a
        través de los canales oficiales.
      </p>
    </div>;
}
function TermsContent() {
  return <div className="prose prose-sm max-w-none text-[#5A6B5A]" data-id="element-90">
      <p className="text-sm text-[#8B9E8B] mb-4" data-id="element-91">
        Última actualización: Enero 2024
      </p>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-92">
        1. Aceptación de Términos
      </h3>
      <p data-id="element-93">
        Al comprar y utilizar la Agenda Antiansiedad de 14 Días, aceptas estos
        términos y condiciones en su totalidad. Si no estás de acuerdo, te
        pedimos no realizar la compra.
      </p>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-94">
        2. Producto Digital
      </h3>
      <p data-id="element-95">
        La Agenda Antiansiedad de 14 Días es un producto digital (ebook en
        formato PDF) que se entrega electrónicamente después de confirmar el
        pago.
      </p>
      <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-96">
        <li data-id="element-97">El acceso es inmediato tras la confirmación del pago</li>
        <li data-id="element-98">El producto es para uso personal únicamente</li>
        <li data-id="element-99">No está permitida la redistribución o reventa del contenido</li>
      </ul>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-100">
        3. Descargo de Responsabilidad
      </h3>
      <p data-id="element-101">
        <strong data-id="element-102">
          Este producto no sustituye la atención médica o psicológica
          profesional.
        </strong>
        La Agenda Antiansiedad es una herramienta de bienestar personal y no
        debe considerarse como tratamiento para trastornos de ansiedad u otras
        condiciones de salud mental.
      </p>
      <p className="mt-2" data-id="element-103">
        Si experimentas síntomas severos de ansiedad, te recomendamos consultar
        con un profesional de la salud mental.
      </p>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-104">
        4. Política de Reembolso
      </h3>
      <p data-id="element-105">
        Debido a la naturaleza digital del producto, no ofrecemos reembolsos una
        vez que el producto ha sido descargado. Sin embargo, si tienes problemas
        técnicos para acceder al contenido, haremos todo lo posible por
        ayudarte.
      </p>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-106">
        5. Propiedad Intelectual
      </h3>
      <p data-id="element-107">
        Todo el contenido de la Agenda Antiansiedad de 14 Días está protegido
        por derechos de autor. Queda prohibida la reproducción, distribución o
        modificación del contenido sin autorización expresa por escrito.
      </p>

      <h3 className="text-lg font-semibold text-[#3D3D3D] mt-6 mb-3" data-id="element-108">
        6. Modificaciones
      </h3>
      <p data-id="element-109">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en esta página.
      </p>
    </div>;
}